import React, { useEffect } from "react";
import { useUserState } from "../../../providers/UserProvider";
import { useActiveRoomState } from "../../../providers/ActiveRoomProvider";
import UserTextMessage from "./TextMessage/userTextMessage";
import AudienceTextMessage from "./TextMessage/audienceTextMessage";
import AudiencePictureMessage from "./PictureMessage/audiencePictureMessage";
import AudienceFileMessage from "./FileMessage/audienceFileMessage";
import sampleUser from "../../../assets/images/sampleUser/118-118.png";
import drSampleUser from "../../../assets/images/sampleUser/drSampleImage.png";
import UserPictureMessage from "./PictureMessage/userPictureMessage";
import UserFileMessage from "./FileMessage/userFileMessage";
import UserVoiceMessage from "./VoiceMessage/userVoiceMessage";
import AudienceVoiceMessage from "./VoiceMessage/audienceVoiceMessage";
import UserVideoMessage from "./VideoMessage/userVideoMessage";
import AudienceVideoMessage from "./VideoMessage/audienceVideoMessage";
import classes from "./index.module.scss";

function Index(props) {
  const user = useUserState();
  const activeRoom = useActiveRoomState();
  let chats = props.chats;
  let userPhotoSrc = user.user_login?.picture || sampleUser;
  let userType = user.user_login?.approve;
  let clientId = user.user_login?.client_id;

  useEffect(() => {
    if (document.getElementById("chat_list_end")) {
      document.getElementById("chat_list_end").scrollIntoView();
    }
  });
  return (
    <div className={classes.mainContainer}>
      <div className={classes.titleBox}>
        {userType === "user" && activeRoom?.dr_info?.doctor_name}
        {userType === "doctor" && activeRoom?.user_info?.user_name}
      </div>
      {chats &&
        chats.map((chat) => {
          if (chat.type === "text") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserTextMessage
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudienceTextMessage
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
          } else if (chat.type === "dossierText") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserTextMessage
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudienceTextMessage
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
          } else if (chat.type === "dossierFile") {
            function getFileExtension(filename) {
              if (filename != null) {
                return filename.split(".").pop();
              } else {
                return;
              }
            }
            let ext = getFileExtension(chat.file);
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              if (ext === "jpg" || ext === "jpeg" || ext === "png") {
                return (
                  <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                    <UserPictureMessage
                      chat={chat}
                      // userId={user.user_login.client_id}
                      imgSrc={
                        userType === "user" && clientId === chat.user_id
                          ? userPhotoSrc
                          : drSampleUser
                      }
                    />
                  </div>
                );
              } else {
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserFileMessage
                    chat={chat}
                    userId={user.user_login.client_id}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>;
              }
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              if (ext === "jpg" || ext === "jpeg" || ext === "png") {
                return (
                  <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                    <AudiencePictureMessage
                      chat={chat}
                      // userId={user.user_login.client_id}
                      imgSrc={
                        userType === "user" && clientId === chat.user_id
                          ? userPhotoSrc
                          : drSampleUser
                      }
                    />
                  </div>
                );
              } else {
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <AudienceFileMessage
                    chat={chat}
                    userId={user.user_login.client_id}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>;
              }
            }
          } else if (chat.type === "dossierPhoto") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserPictureMessage
                    chat={chat}
                    // userId={user.user_login.client_id}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudiencePictureMessage
                    chat={chat}
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
          } else if (chat.type === "dossierVoice") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserVoiceMessage
                    chat={chat}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                    // userId={user.user_login.client_id}
                    key={chat.key}
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudienceVoiceMessage
                    chat={chat.message}
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
          } else if (chat.type === "dossierVideoMessage") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserVideoMessage
                    src={chat.file}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                    userId={user.user_login.client_id}
                    key={chat.key}
                    chat={chat}
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudienceVideoMessage
                    src={chat.file}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                    userId={user.user_login.client_id}
                    key={chat.key}
                    chat={chat}
                  />
                </div>
              );
            }
          } else if (chat.type === "prescriptionPhoto") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserPictureMessage
                    chat={chat.message}
                    // userId={user.user_login.client_id}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudiencePictureMessage
                    chat={chat.message}
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            }
          } else if (chat.type === "prescriptionFile") {
            function getFileExtension(filename) {
              if (filename != null) {
                return filename.split(".").pop();
              } else {
                return;
              }
            }
            let ext = getFileExtension(chat.file);
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              if (ext === "jpg" || ext === "jpeg" || ext === "png") {
                return (
                  <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                    <UserPictureMessage
                      chat={chat}
                      // userId={user.user_login.client_id}
                      imgSrc={
                        userType === "user" && clientId === chat.user_id
                          ? userPhotoSrc
                          : drSampleUser
                      }
                    />
                  </div>
                );
              } else {
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserFileMessage
                    chat={chat}
                    // userId={user.user_login.client_id}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>;
              }
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              if (ext === "jpg" || ext === "jpeg" || ext === "png") {
                return (
                  <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                    <AudiencePictureMessage
                      chat={chat}
                      // UserId={user.user_login.client_id}
                      imgSrc={
                        userType === "user" && clientId === chat.user_id
                          ? userPhotoSrc
                          : drSampleUser
                      }
                    />
                  </div>
                );
              } else {
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <AudienceFileMessage
                    chat={chat}
                    userId={user.user_login.client_id}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>;
              }
            }
          } else if (chat.type === "prescriptionVoice") {
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id === user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                  <UserVoiceMessage
                    chat={chat}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                    // userId={user.user_login.client_id}
                    key={chat.key}
                  />
                </div>
              );
            }
            if (
              chat.user_id &&
              user.user_login &&
              chat.user_id !== user.user_login.client_id
            ) {
              return (
                <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                  <AudienceVoiceMessage
                    chat={chat.message}
                    message={chat.message}
                    imgSrc={
                      userType === "user" && clientId === chat.user_id
                        ? userPhotoSrc
                        : drSampleUser
                    }
                  />
                </div>
              );
            } else if (chat.type === "prescriptionVideoMessage") {
              if (
                chat.user_id &&
                user.user_login &&
                chat.user_id === user.user_login.client_id
              ) {
                return (
                  <div key={chat.key} style={{ alignSelf: "flex-start" }}>
                    <UserVideoMessage
                      src={chat.file}
                      imgSrc={
                        userType === "user" && clientId === chat.user_id
                          ? userPhotoSrc
                          : drSampleUser
                      }
                      userId={user.user_login.client_id}
                      key={chat.key}
                      chat={chat}
                    />
                  </div>
                );
              }
              if (
                chat.user_id &&
                user.user_login &&
                chat.user_id !== user.user_login.client_id
              ) {
                return (
                  <div key={chat.key} style={{ alignSelf: "flex-end" }}>
                    <AudienceVideoMessage
                      src={chat.file}
                      imgSrc={
                        userType === "user" && clientId === chat.user_id
                          ? userPhotoSrc
                          : drSampleUser
                      }
                      userId={user.user_login.client_id}
                      key={chat.key}
                      chat={chat}
                    />
                  </div>
                );
              }
            }
          }
          return null;
        })}
      <div id="chat_list_end" />
    </div>
  );
}

export default Index;
